import useTableFilters from "@/hooks/useTableFilters";
import {
  MonthFilter,
  SalesCoordinatorFilter,
  ClientFilter,
  DepartmentsFilter,
  AccountManagerFilter,
} from "../components/common-filters";
import { FilterActions } from "components/filter/actions";

export default function BucketFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  clearFilters,
  defaultFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      jobs: {
        billables: {
          collected_date: undefined,
        },
      },
      ...defaultFilters,
    },
  });
  return (
    <div className="w-full p-4 space-y-4">
      <MonthFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        jobType="bucket"
      />

      <AccountManagerFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />

      <SalesCoordinatorFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />

      <ClientFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
        isOpen={isOpen}
      />

      <DepartmentsFilter
        localFilters={localFilters}
        handleSetLocalFilters={handleSetLocalFilters}
      />

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </div>
  );
}
